import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MeetingListPage } from './meeting-list';
import { UserHeaderComponentModule } from '../../components/header/header.module';
import { MomentModule } from 'ngx-moment';

@NgModule({
  declarations: [
    MeetingListPage,
  ],
  imports: [
    IonicPageModule.forChild(MeetingListPage),
    UserHeaderComponentModule,
    MomentModule
  ],
})
export class MeetingListPageModule {}



// WEBPACK FOOTER //
// ./src/pages/meeting-list/meeting-list.module.ts